























































































































































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class OrbitLearnMoreModal extends Vue {
  @Prop({type: Boolean, required: true}) isVisible!: boolean

  closeModal() {
    this.$emit('close')
  }
}
